/**
 * Per-minute AWS Transcribe rates (USD), by JobSpec.mode. Source of truth: ADR-003
 * (docs/adr-003-streaming-and-live-addons.md) — batch is cheaper, streaming is the live premium.
 * A client cost/min indicator is `rate × elapsedMinutes`. If AWS pricing changes, update HERE and
 * the mirrored copies in packages/core/CLAUDE.md's parallel-implementation note AND
 * backend/src/scribe/metering/rates.py (TRANSCRIBE_BATCH_USD_PER_MIN / TRANSCRIBE_STREAMING_USD_PER_MIN
 * — docs/specs/admin-1.md §4), which mirrors these exact values for server-side usage-cost estimates.
 */
export const TRANSCRIPTION_RATE_PER_MIN_USD = {
    batch: 0.006,
    streaming: 0.01,
};
/**
 * Self-hosted Whisper batch engine (docs/specs/whisper-1.md §6), USD per audio-minute. NOT a list
 * price: an all-in ESTIMATE (GPU spot $/hr ÷ measured realtime factor + idle/cold-start overhead)
 * from that spec's cost model, $0.048/audio-hour. Mirrors backend/src/scribe/metering/rates.py
 * `_DEFAULT_WHISPER_BATCH_USD_PER_MIN` (server-side overridable via
 * SCRIBE_RATE_WHISPER_BATCH_PER_MIN_USD — the Admin screen's cost figures come from the server, so
 * an override there needs no client change).
 */
export const WHISPER_BATCH_RATE_PER_MIN_USD = 0.0008;
/** Batch rate per engine (USD/min) — which engine ran decides the cost of a batch minute. */
export const BATCH_RATE_PER_MIN_USD_BY_ENGINE = {
    "aws-transcribe": TRANSCRIPTION_RATE_PER_MIN_USD.batch,
    whisper: WHISPER_BATCH_RATE_PER_MIN_USD,
};
/** Estimated cost in USD for a session of `mode` lasting `seconds`. */
export function estimateTranscriptionCostUsd(mode, seconds) {
    return TRANSCRIPTION_RATE_PER_MIN_USD[mode] * (seconds / 60);
}
//# sourceMappingURL=pricing.js.map